/** Keep a week's confirmed days if a later day fails; never present a partial week as complete. */
export async function submitSpecialDietWeek<T>(
  days: T[],
  submit: (day: T) => Promise<{ status: string }>,
): Promise<{ completed: number; error: string | null }> {
  let completed = 0
  try {
    for (const day of days) {
      const result = await submit(day)
      if (!['SUBMITTED', 'CONFIRMED', 'FULFILLED'].includes(result.status)) {
        throw new Error('A meal is awaiting payment. Resolve it before continuing.')
      }
      completed++
    }
    return { completed, error: null }
  } catch (error) {
    return { completed, error: error instanceof Error ? error.message : 'Unable to complete the week.' }
  }
}
